export const FORGOT_API_STARTED = 'cboard/ResetPassword/FORGOT_API_STARTED' as const;
export const FORGOT_API_SUCCESS = 'cboard/ResetPassword/FORGOT_API_SUCCESS' as const;
export const FORGOT_API_FAILURE = 'cboard/ResetPassword/FORGOT_API_FAILURE' as const;
